(function () {

    'use strict';

    angular.module('app').controller('AdministrationUserController', AdministrationUserController);

    AdministrationUserController.$inject = [
        '$rootScope',
        '$location',
        'AdminPermissionService',
        'toastr',
        '$routeParams',
        'ConfirmationModalFactory',
        '$q',
        'FleetService',
        '$scope'
    ];

    function AdministrationUserController(
        $rootScope,
        $location,
        AdminPermissionService,
        toastr,
        $routeParams,
        ConfirmationModalFactory,
        $q,
        FleetService,
        $scope
    ) {
        const deleteConfirmationModal = new ConfirmationModalFactory({}, {
            message: 'messages.warning.deleteAdminAccount.MESSAGE',
            code: 'messages.warning.deleteAdminAccount.CODE'
        });
        const vm = this;

        vm.admin = {}
        $scope.userAreas = [];
        $scope.userCarrier = [];
        vm.onDeleteBtnAccountClicked = onDeleteBtnAccountClicked;
        vm.onBackBtnClicked = onBackBtnClicked;
        vm.onSaveUpdateBtnClicked = onSaveUpdateBtnClicked;

        init();

        function init() {
            vm.id = getAdminUserId();
            if (vm.id) {
                loadUpdateFormData();
                return;
            }

            loadCreateFormData();
            setGlobalProfileData();
        }

        function getAdminUserId() {
            return $routeParams.accountId || false;
        }

        function setGlobalProfileData() {
            vm.globalProfile = $rootScope.GlobalProfile;
        }

        function loadUpdateFormData() {
            vm.isLoading = true;
            vm.loadingMessage = 'Loading user details';
            vm.viewMode = true;

            $q.all({
                allPermissions: getAllPermissions(),
                userDetails: getAdminUserDetails()
            }).then(data => {
                const userPermissions = getUserSelectedPermissions(data.userDetails.modules, data.allPermissions, data.userDetails.areas, data.userDetails.carriers);
                data.userDetails.user.employeeId = data.userDetails.employeeId;
                console.log(data)
                angular.extend(vm.admin, {
                    accessCompany: data.userDetails.companies,
                    user: data.userDetails.user,
                    permissionAccess: userPermissions.admin,
                    dashboardAccess: userPermissions.dashboard
                });
                vm.getArea = data.userDetails.areas
                vm.isLoading = false;
            }, error => {
                toastr.error(error.message, 'Error!');
                vm.isLoading = false;
            });
        }

        function getUserSelectedPermissions(userPermissions, allPermissions, areas, carrier) {
            const permissions = {
                admin: [],
                dashboard: []
            };
            $scope.userAreas = areas
            allPermissions.admin.forEach(permission => {
                const foundPermission = userPermissions.find(userPermission => permission.id === userPermission.id);
                if (permission.id === 18) {
                    permission.areas = true
                }

                if (permission.id === 8) {
                    permission.carrier = true
                }
                permissions.admin.push({
                    name: permission.name,
                    id: permission.id,
                    active: foundPermission ? true : false,
                    carrier: permission.carrier,
                    areas: permission.areas,
                    selectedAreas: areas,
                    selectedCarrier: carrier
                })

            });
            allPermissions.dashboard.forEach(permission => {
                const foundPermission = userPermissions.find(userPermission => permission.id === userPermission.id);
                permissions.dashboard.push({
                    name: permission.name,
                    id: permission.id,
                    active: foundPermission ? true : false,
                    areas: permission.areas,
                    selectedAreas: areas
                })

            });
            return permissions;
        }

        function formatAreas(data) {
            const payload = [];
            data.forEach(item => {
                payload.push({
                    areaId: item.areaName,
                    id: item.areaId
                })
            })


            return payload;
        }

        function getAdminUserDetails() {
            const defer = $q.defer();
            AdminPermissionService.AdminCurrentUser.getAdminUserDetails(success => {
                const userData = success.content[0];
                if (!userData) {
                    defer.reject({ message: 'User details not found!' });
                }
                defer.resolve(userData);
            }, error => {
                defer.reject(error);
            }, vm.id);
            return defer.promise;
        }

        function loadCreateFormData() {
            vm.loadingMessage = 'Loading default permissions';
            $q.all({
                permissions: getAllPermissions()
            }).then(data => {
                angular.forEach(data.permissions.admin, item => {
                    if (item.id === 18) {
                        item.areas = true;
                        item.selectedAreas = []
                    }

                    if (item.id === 8) {
                        item.carrier = true;
                        item.selectedCarrier = []
                    }
                })

                angular.extend(vm.admin, {
                    accessCompany: [],
                    permissionAccess: data.permissions.admin,
                    dashboardAccess: data.permissions.dashboard
                });
                vm.isLoading = false;
            }, error => {
                vm.isLoading = false;
                toastr.error(error.message, 'Error!');
            });
        }

        function getAllPermissions() {
            const defer = $q.defer();
            AdminPermissionService.AdminPermissionModule.getPermissionModule(success => {
                const permission = {
                    admin: [],
                    dashboard: []
                };

                success.content.forEach(module => {
                    if (module.moduleType === "Dashboard") {
                        permission.dashboard.push(module)
                    }
                    else {
                        permission.admin.push(module)
                    }
                });

                defer.resolve(permission);
            }, error => {
                defer.reject(error);
            }, { size: 50, sort: 'name,desc' });
            return defer.promise;
        }

        function onSaveUpdateBtnClicked(form) {
            form.$setSubmitted();
            if (form.$invalid) { return; }
            if (vm.id) {
                updateAdminUser();
                return;
            }

            createAdminUser();
        }

        function areaSelected() {
            const payload = [];

            vm.admin.permissionAccess.forEach(item => {
                if (item.id === 18) {
                    if (item.selectedAreas.length > $scope.userAreas.length) {
                        $scope.userAreas = item.selectedAreas
                    }

                    $scope.userAreas.forEach(area => {
                        payload.push(area.areaId)
                    })
                }
            })
            return payload
        }

        function carrierProfileSelected() {
            const payload = [];
            vm.admin.permissionAccess.forEach(item => {
                if (item.id === 8) {
                    item.selectedCarrier.forEach(carrier => {
                        payload.push(carrier.id ? carrier.id : carrier.carrierId)
                    })
                }
            })

            return payload
        }

        function companyOfficeHasAccess() {
            const payload = [];
            vm.admin.accessCompany.forEach(item => {
                const officeIds = [];
                if (item.offices) {
                    item.offices.forEach(ofc => {
                        officeIds.push(ofc.id || ofc.officeId)
                    });
                }

                payload.push({
                    companyId: item.id,
                    officeIds: officeIds
                });
            });
            return payload;
        }

        function updateAdminUser() {
            vm.isSavingData = true;

            const dataLoad = AdminPermissionService.AdminCurrentUser.generatePayload(vm.admin);
            const carrier = !!dataLoad.moduleIds.find(item => item === 8);
            const areaAndRoute = !!dataLoad.moduleIds.find(item => item === 18);
            let payload = {
                employeeId: vm.admin.user.employeeId,
                firstName: vm.admin.user.firstName,
                lastName: vm.admin.user.lastName,
                moduleIds: dataLoad.moduleIds,
                phone1: vm.admin.user.phone1,
                areaIds: areaAndRoute ? areaSelected() : [],
                companies: companyOfficeHasAccess(),
                carrierIds: carrier ? carrierProfileSelected() : []
            }
            AdminPermissionService.AdminCurrentUser.updateDetails(vm.id, success => {
                toastr.success('Account updated', 'Success!');

                vm.isSavingData = false;
            }, error => {
                toastr.error(error.message, 'Error!');
                vm.isSavingData = false;
            }, payload);
        }


        function createAdminUser() {
            vm.isSavingData = true;
            const adminData = angular.extend(vm.admin, {
                permissionGroupId: vm.globalProfile.permissionGroup.id,
                officeId: vm.globalProfile.office.id,
                companyIds: vm.globalProfile.company.id,
                areaIds: areaSelected(),
                accessCompany: companyAccess()
            });

            const payload = AdminPermissionService.AdminCurrentUser.generatePayload(adminData);

            AdminPermissionService.AdminCurrentUser.createAdminUserAccount(success => {
                vm.isSavingData = false;
                toastr.success('Created successfully', 'Success!');
                gotToAdminUserDetails(success.user.id);
            }, error => {
                toastr.error(errorMessege(error.message), 'Error!')
                vm.isSavingData = false;
            }, payload);
        }

        function errorMessege(error) {
            let msg = error.includes('Email already used')
            if (msg) {
                return 'User with this email already exists';
            }
            return error
        }

        function gotToAdminUserDetails(adminAccountId) {
            $location.path(`/administration/admin-accounts/${adminAccountId}`);
        }

        function onDeleteBtnAccountClicked() {
            deleteConfirmationModal.getInstance().result.then(function (cond) {
                if (!cond) { return; }
                deleteAdminAccount();
            });
        }

        function deleteAdminAccount() {
            AdminPermissionService.AdminCurrentUser.deleteAdminUserAccount(success => {
                toastr.error('Admin account deleted', 'Success!');
                goBackToAdminAccounts();
            }, error => {
                toastr.error(error.message, 'Error!');
            }, vm.id);
        }

        function onBackBtnClicked() {
            goBackToAdminAccounts();
        }

        function goBackToAdminAccounts() {
            $location.path('/administration/admin-accounts');
        }
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/administration/AdministrationUserController.js